import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography} from '@mui/material';

import {ChartLineIcon, HeartbeatIcon, LaptopIcon, SmileIcon} from '../../../../../../assets/company_benefits';
import {LanguageContext} from '../../../../../../contexts/LanguageContext/LanguageContext';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {BenefitClass} from '../../types/CultureDashboardBenefitsTypes';

interface CompanyTopBenefitsProps {
  companyTopBenefits: BenefitClass[];
}

export default function CompanyTopBenefits({companyTopBenefits}: CompanyTopBenefitsProps) {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  const boxStyles: SxProps = {
    backgroundColor: 'white',
    padding: '32px 16px',
    border: `1px solid ${orangeColors[3]}`,
    borderRadius: 2,
    flexBasis: {xs: '100%', md: '30%'},
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const iconColor = greenColors[700];

  const getIcon = (category: string) => {
    switch (category) {
      case 'office':
        return LaptopIcon;
      case 'financial':
        return ChartLineIcon;
      case 'health':
        return HeartbeatIcon;
      case 'happiness':
        return SmileIcon;
      default:
        return LaptopIcon;
    }
  };

  return (
    <Grid container>
      <Grid item marginTop={8} marginBottom={2}>
        <Typography variant='h2'>{t('companyCultureDashboard.benefitsTitle')}</Typography>
      </Grid>

      <Grid item container gap={2} marginBottom={2}>
        {companyTopBenefits.slice(0, 2).map((benefit, index) => {
          const IconComponent = getIcon(benefit.category);
          return (
            <Box key={index} sx={boxStyles}>
              <Box sx={{color: iconColor, height: 40, width: 40, marginBottom: 2}}>
                <IconComponent width={40} height={40} />
              </Box>
              <Typography variant='body1' textAlign={'center'}>
                {benefit.benefit.labels[currentLanguage]}
              </Typography>
            </Box>
          );
        })}
      </Grid>

      <Grid item container gap={2}>
        {companyTopBenefits.slice(2).map((benefit, index) => {
          const IconComponent = getIcon(benefit.category);
          return (
            <Box key={index} sx={boxStyles}>
              <Box sx={{color: iconColor, height: 40, width: 40, marginBottom: 2}}>
                <IconComponent width={40} height={40} />
              </Box>
              <Typography variant='body1' textAlign={'center'}>
                {benefit.benefit.labels[currentLanguage]}
              </Typography>
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
}
